module.exports = __webpack_public_path__ + "img/british-admiral-richard-howe.1cf62c38.png";